import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import Sygnet from '../Map/Sygnet'

const legend = [
  { color: 'red', desc: 'magAvailableWithoutAKeyCanBeOpenedRemotelyFromYourPhone' },
  { color: 'black', desc: 'lockedWithAPadlockWithACodeThatYouWillReceiveAfterRentingMag' },
  { color: 'yellow', desc: 'weAreBuildingANewMagSquareHere' },
]

const LegendPopup = () => {
  const { t } = useTranslation('map')
  return (
    <Popup>
      <div className='popup__legend'>
        <div className='popup__title'>
          <div>{t('mapLegend')}</div>
          <div>{t('seeTagDescriptions')}</div>
        </div>

        <div className='legend__list'>
          {legend.map(({ color, desc }, i) => <div
            key={i}
            className='list__item center'>
            <Sygnet color={color} />
            <div>{t(desc)}</div>
          </div>)}
        </div>
      </div>
    </Popup>
  )
}

export default LegendPopup